import React from 'react';
import useMobileWidth from 'hooks/useMobileWidth';
import River from 'components/shared/River';
import * as styles from './styles/styles.module.scss';
import { BENEFITS, Benefit } from './benefitsUtil';
import BenefitCard from './BenefitCard';

// Careers page does not need translations
const Benefits = (): JSX.Element => {
  const shouldCollapseCards = useMobileWidth(768);
  const benefitCards = BENEFITS.map((benefit: Benefit) => <BenefitCard key={benefit.id} benefit={benefit} />);

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <div className={styles.textContainer}>
          <h2 className={styles.header}>
            With great responsibility comes <span className={styles.greatBenefits}>great benefits</span>
          </h2>
          <div className={styles.benefitsText}>
            We’re focused on creating an environment where everyone can do their best work and thrive. These benefits are offered to all salaried
            employees.
          </div>
        </div>
        {!shouldCollapseCards && <div className={styles.benefitsContainer}>{benefitCards}</div>}
      </div>
      {shouldCollapseCards && (
        <River useSlick={true} className={styles.river} slickSettings={{ slidesToShow: 1, lazyLoad: false }}>
          {benefitCards}
        </River>
      )}
    </div>
  );
};

export default Benefits;
